import { call, put, select } from 'redux-saga/effects';
import { API, getServerConfig } from '../../api';

const getIsPublic = ({ isPublic }) => isPublic;

export function* checkForAccess() {
  const serverConfig = yield select(getServerConfig);
  const isPublic = yield select(getIsPublic);

  try {
    if (serverConfig.namespace === 'homepage') {
      yield put({
        type: 'FETCH_CITIES',
      });
      return;
    }

    const path = `/access/${serverConfig.namespace}`;
    const results = yield call(API, 'get', 'api', path);

    if (results.allowed === false) {
      yield put({
        type: 'SET_ACCESS',
        payload: {
          allowed: false,
        },
      });
      return;
    }

    yield put({
      type: 'SET_ACCESS',
      payload: {
        allowed: results.allowed,
      },
    });

    yield put({ type: 'FETCH_FILTERS' });

    yield put({ type: 'FETCH_LAYERS' });

    if (!isPublic) yield put({ type: 'FETCH_CUSTOM_LAYERS' });
  } catch (e) {
    yield put({
      type: 'SET_ACCESS',
      payload: {
        allowed: false,
      },
    });
  }
}
